// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'babel-polyfill'
import moment from 'moment'
import axios from 'axios'
import VueAxios from 'vue-axios'
import echarts from 'echarts'
import JsonViewer from 'vue-json-viewer'
import Sortable from 'sortablejs'

// import echarts from 'echarts/lib/echarts'
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import VueClipboard from 'vue-clipboard2'

Vue.use(VueQuillEditor)
Vue.use(VueClipboard)
Vue.use(JsonViewer)

Vue.use(VueAxios, axios)
Vue.use(ElementUI, { size: 'mini' })
Vue.config.productionTip = false
Vue.prototype.$notify = ElementUI
Vue.prototype.$moment = moment
Vue.prototype.$Sortable = Sortable
Vue.prototype.$echarts = echarts
// moment.locale('zh-cn')

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js